import { ArrayInput, FormDataConsumer, SimpleFormIterator } from "react-admin";
import Inputs from "./Inputs";

export default function SaleItemForm() {
  return (
    <ArrayInput
      source="sale_items"
      defaultValue={[
        {
          sale_order_item_id: "",
          sent_quantity: "",
          bonus_quantity: "",
          quantity: "", // order quantity disabled
          price: "", // disabled
          name: "", // disabled
          disc: "",
          spc_disc: "",
          subtotal: "0", // disabled
          transport_discount: "0", // disabled
        },
      ]}
    >
      <SimpleFormIterator
        disableReordering
        getItemLabel={(index) => `#${index + 1}`}
        fullWidth={true}
        sx={{
          "& .RaSimpleFormIterator-line": {
            border: "none",
          },
        }}
      >
        <FormDataConsumer>{Inputs}</FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
}
